import {
    CardActionArea,
    Divider,
    List,
    ListItem,
    Paper,
} from "@material-ui/core";
import DayIcon from "@material-ui/icons/DateRange";
import React from "react";
import MapIcon from '@material-ui/icons/Map';
import TimeIcon from '@material-ui/icons/WatchLater';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import NoMapIcon from '@material-ui/icons/ExploreOff';
import GeneralInfoListItem from "./GeneralInfoListItem";
import useBuildings from "../../../Common/Context/Consumers/useBuildings";
import styled from "styled-components";
import Building from "../../../Common/Models/Building";
import openWebPage from "../../../Common/Helper/openWebPage";
import CourseSchedule from "../../../Common/Models/CourseSchedule";
import DetailListItem from "../../../Common/Views/ListItems/DetailListItem";

const ListItemContainer = styled(ListItem)`
  width: 100%;
`;

const ContentListContainer = styled(List)`
  width: 100%;
`;

const MapSectionContainer = styled(Paper)`
  overflow: hidden;
`;

const MapImg = styled.img`
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
`;

const ScheduleListItem = (props: any) => {
    const {schedule} = props;
    const buildings: any = useBuildings();

    let days = (schedule.days.length > 0) ? schedule.days.reduce((previous: string, current: string) => {
        return previous + ', ' + current
    }): [];

    const building = ((schedule: CourseSchedule, buildings: Building[]): Building | null => {
        if (schedule.location && schedule.location != " ") {

            let buildingCode = schedule.location.split(' ')[0];
            return buildings.filter(
                (building: any) => buildingCode == building.code
            )[0];
        }
        return null;
    })(schedule, buildings);

    const openMap = (building: Building) => {
        if (building) {
            let url = `maps:q=${building.coordinates}`
            openWebPage(url);
        }
    };

    return (
        <>
            <ListItemContainer disableGutters>
                <ContentListContainer disablePadding>
                    {schedule.days.length > 0 &&
                        <DetailListItem
                            title={days}
                            icon={<DayIcon />}
                            item={schedule}
                            showDivider={true}
                            displayFavorite={false}
                            />
                   }
                    <DetailListItem
                        title={schedule.startTime + ' - ' + schedule.endTime}
                        icon={<TimeIcon/>}
                        item={schedule}
                        showDivider={true}
                        displayFavorite={false}
                    />
                    { schedule.meetType &&
                        <DetailListItem
                            title={schedule.meetType}
                            icon={<MeetingRoomIcon/>}
                            item={schedule}
                            showDivider={true}
                            displayFavorite={false}
                        />
                    }
                    {schedule.location && schedule.location != " " &&
                        <DetailListItem
                            title={schedule.location}
                            icon={<MapIcon/>}
                            item={schedule}
                            showDivider={true}
                            displayFavorite={false}
                        />
                    }
                    {building ?
                            (
                            <ListItem disableGutters xs={12}>
                                <MapSectionContainer elevation={3}>
                                    <CardActionArea
                                        onClick={() => openMap(building)}>
                                        <MapImg src={building.url}/>
                                    </CardActionArea>
                                </MapSectionContainer>
                            </ListItem>
                            )
                            :(
                                <GeneralInfoListItem icon={<NoMapIcon />} title={"NO LOCATION"} />
                           )
                    }

                </ContentListContainer>
            </ListItemContainer>
            <Divider variant={'middle'} component={'li'} />
        </>
    )
};

export default ScheduleListItem;